/**
 * @todo Examine enumerable properties
 */

export function isEmptyObj(obj) {
  // null and undefined are "empty"
  if (obj == null) return true

  // Assume if it has a length property with a non-zero value
  // that that property is correct.
  if (obj.length && obj.length > 0) return false
  if (obj.length === 0) return true

  // If it isn't an object at this point
  // it is empty, but it can't be anything *but* empty
  // Is it empty?  Depends on your application.
  if (typeof obj !== 'object') return true

  // If you only need to handle ECMAScript5 browsers,
  // you can use Object.getOwnPropertyNames instead of the hasOwnProperty loop.
  // This will ensure that even if the object only has non-enumerable properties
  // this function will still give you the correct results.
  if (Object.getOwnPropertyNames(obj).length > 0) return false

  // Otherwise, does it have any properties of its own?
  // Note that this doesn't handle
  // toString and valueOf enumeration bugs in IE < 9
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return false
  }

  return true
}
